import { render, staticRenderFns } from "./AgreementChangeLogDrawer.vue?vue&type=template&id=0c8ea9e4&scoped=true"
import script from "./AgreementChangeLogDrawer.vue?vue&type=script&lang=js"
export * from "./AgreementChangeLogDrawer.vue?vue&type=script&lang=js"
import style0 from "./AgreementChangeLogDrawer.vue?vue&type=style&index=0&id=0c8ea9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ea9e4",
  null
  
)

export default component.exports